import { FC } from 'react';
import { useSelector } from 'react-redux';

import { filterSelectors } from '../../../../../store/modules/filter';

import Wrapper, { Title } from './Wrapper';

const DesktopNotFound: FC = () => {
  const searchName = useSelector(filterSelectors.selectSearchName);
  const { name } = useSelector(filterSelectors.selectSavedFilters);

  const searchText = searchName || name;

  const text = searchText
    ? `No keyword matches for “${searchText}” in templates`
    : 'No templates found.';

  return (
    <Wrapper>
      <Title>{text}</Title>
    </Wrapper>
  );
};

export default DesktopNotFound;
